import { z } from "zod";

// Role catalog used by AuthenticatedUser. The actual permission model
// lives in ./permissions.ts (the dotted-key catalog and resolveEffectivePermissions).
// This file retains only `Role`/`roleSchema` to preserve the AuthenticatedUser
// shape — the older granular `Permission`/`DEFAULT_PERMISSIONS` exports were
// never consumed and were superseded by ./permissions.ts on 2026-05-23.
export const roleSchema = z.enum([
	"super_admin",
	"owner",
	"doctor",
	"receptionist",
	"accountant",
	"nurse",
	"patient",
]);
export type Role = z.infer<typeof roleSchema>;
